import {gql} from 'graphql-request';

const GET_PRODUCT_LIST_HERO_BY_SLUG_QUERY = gql`
  query getProductListHero(
    $slug: String
    $sort: ProductsQuerySortParameter
    $filter: ProductFilterParameter
    $facets: [String]
  ) {
    productList(slug: $slug, sort: $sort, filter: $filter, facets: $facets) {
      backgroundColor
      breadcrumbs {
        label
        url
      }
      description
      imageUrl
      isSeoIndexable
      seoDescription
      seoTitle
      title
      type
    }
  }
`;

export default GET_PRODUCT_LIST_HERO_BY_SLUG_QUERY;
